// extracted by mini-css-extract-plugin
var _1 = "_5ud4H__gameWrapper";
var _2 = "_5ud4H__wrapper";
export { _1 as "gameWrapper", _2 as "wrapper" }
